import { createContext, useContext } from 'react'
import type { UsuarioSesion } from '../api/tipos.js'
import { tienePermiso } from '../navegacion/permisos.js'

export interface Sesion {
  usuario: UsuarioSesion
  cerrarSesion: () => Promise<void>
  /** Tras cambiar la contraseña temporal o los permisos propios. */
  refrescar: () => Promise<void>
}

const ContextoSesion = createContext<Sesion | undefined>(undefined)

export const ProveedorSesion = ContextoSesion.Provider

export function useSesion(): Sesion {
  const sesion = useContext(ContextoSesion)
  if (!sesion) throw new Error('useSesion se usó fuera de una sesión iniciada.')
  return sesion
}

/**
 * `usePuede('oci.derivar')` para decidir si se renderiza un control.
 *
 * `UI-9`: un control sin permiso **no se renderiza**; no se muestra
 * deshabilitado. Un botón gris sugiere que existe una acción que en realidad
 * no está disponible para esa persona, y lleva a pedir soporte por algo que no
 * es un fallo.
 */
export function usePuede(...permisos: readonly string[]): boolean {
  const { usuario } = useSesion()
  return tienePermiso(usuario, ...permisos)
}
